import React, { useMemo, useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import * as THREE from "three";

function RotatingLens({ eyeResult, selectedMaterialLabel }) {
  const meshRef = useRef();

  const geometry = useMemo(() => {
    const shape = new THREE.Shape();
    const pts = eyeResult?.shapePoints ?? [];

    if (!pts.length) return new THREE.BoxGeometry(1, 1, 0.1);

    shape.moveTo(pts[0].x / 20, pts[0].y / 20);

    for (let i = 1; i < pts.length; i++) {
      shape.lineTo(pts[i].x / 20, pts[i].y / 20);
    }

    shape.closePath();

    const comparisons = eyeResult?.comparisons ?? [];

const comp =
  comparisons.find((item) => item.label === selectedMaterialLabel) ??
  comparisons[0];

    const thickness =
      comp?.thicknessType === "center"
        ? comp?.centerThickness
        : comp?.edgeThickness;

    const depth = Math.max(0.06, (thickness ?? 1.5) / 25);

    return new THREE.ExtrudeGeometry(shape, {
      depth,
      bevelEnabled: false,
      steps: 1
    });
  }, [eyeResult, selectedMaterialLabel]);

  useFrame((_, delta) => {
    if (meshRef.current) meshRef.current.rotation.y += delta * 0.5;
  });

  return (
    <mesh ref={meshRef} geometry={geometry} rotation={[0.4, 0.3, 0]}>
      <meshPhysicalMaterial
        transmission={0.95}
        roughness={0.05}
        thickness={0.5}
        transparent
        opacity={0.9}
      />
    </mesh>
  );
}

export default function Lens3DPreview({ title, eyeResult, selectedMaterialLabel }) {
  return (
    <div style={{ height: 260, borderRadius: 12, overflow: "hidden" }}>
      <div style={{ padding: "6px 10px" }}>{title}</div>

      <Canvas camera={{ position: [0, 0, 4] }}>
        <ambientLight intensity={1.3} />
        <directionalLight position={[4, 4, 5]} intensity={2} />

        <RotatingLens
  eyeResult={eyeResult}
  selectedMaterialLabel={selectedMaterialLabel}
/>

        <OrbitControls enablePan={false} />
      </Canvas>
    </div>
  );
}